import * as XLSX from "xlsx";

export type ParsedFile = {
  headers: string[];
  rows: string[][];
  totalRows: number;
};

/** Le CSV/XLSX/XLS e retorna headers + rows como string[][]. Valores vazios viram "". */
export async function parseImportFile(file: File): Promise<ParsedFile> {
  const buf = await file.arrayBuffer();
  const wb = XLSX.read(buf, { type: "array", raw: false });
  const firstSheet = wb.SheetNames[0];
  if (!firstSheet) throw new Error("Arquivo sem planilhas.");
  const sheet = wb.Sheets[firstSheet];
  const aoa = XLSX.utils.sheet_to_json<string[]>(sheet, {
    header: 1,
    raw: false,
    defval: "",
    blankrows: false,
  });
  if (aoa.length === 0) throw new Error("Arquivo vazio.");

  const headerRow = aoa[0] ?? [];
  const headers = headerRow.map((h) => String(h ?? "").trim()).filter((h) => h !== "");
  if (headers.length === 0) throw new Error("Arquivo sem cabecalho na primeira linha.");

  const rows: string[][] = [];
  for (let i = 1; i < aoa.length; i++) {
    const row = aoa[i] ?? [];
    const normalized: string[] = [];
    for (let j = 0; j < headers.length; j++) {
      normalized.push(String(row[j] ?? "").trim());
    }
    if (normalized.some((v) => v !== "")) rows.push(normalized);
  }

  return { headers, rows, totalRows: rows.length };
}

/** Extrai as primeiras N linhas como objetos {header: value} pra preview. */
export function previewRows(parsed: ParsedFile, max = 5): Record<string, string>[] {
  return parsed.rows.slice(0, max).map((row) => {
    const obj: Record<string, string> = {};
    parsed.headers.forEach((h, idx) => {
      obj[h] = row[idx] ?? "";
    });
    return obj;
  });
}
